import axios from 'axios'

export default function request(method, url, par) {  //暴露 request 给我们好API 管理
  method = method.toLocaleLowerCase()   //封装RESTful API的各种请求方式 以 post get delete为例
  if (method === 'post') {
    return axios.post(url, par)    //axios的post 默认转化为json格式
  } else if (method === 'get') {     
    return axios.get(url, {
      params: par
    })
  } else if (method === 'delete') {
    return axios.delete(url, {
      data:par
    })
  }else if (method === 'put') {
    return axios.put(url, par)
  }
}

